export default __webpack_public_path__ + "static/media/equals.93d72a03.svg";